export default class FileListConverter {
  static fileListToArray(fileList: FileList): File[] {
    return Array.from(fileList);
  }
}